import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetSupportersClubsResponse } from './types/get-supporters-clubs.type';

export const getSupportersClubs = async (): Promise<AxiosResponse<GetSupportersClubsResponse>> => {
	const response = await api.get('/account/supporters-clubs');

	return response;
};
